import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";

const apiUrl = Config.apiUrl;

const MOVEMENT_TYPE_SANGRIA = 1;

const CashRegister = () => {
    const navigate = useNavigate();
    const [, setLoading] = useRecoilState(loadingAtom);
    const [openCashRegister, setOpenCashRegister] = useState(undefined);
    const [openingValue, setOpeningValue] = useState('');
    const [report, setReport] = useState(null);

    async function fetchReport(cashRegisterId) {
        try {
            const url = apiUrl + '/api/cash-registers/' + cashRegisterId + '/report';
            const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
            setReport(response);
        } catch (error) {
            console.error('Error fetching cash register report:', error);
        }
    }

    async function makeQuery() {
        try {
            setLoading(true);
            const url = apiUrl + '/api/cash-registers/open';
            const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
            setOpenCashRegister(response);
            if (response) {
                await fetchReport(response.id);
            } else {
                setReport(null);
            }
        } catch (error) {
            setOpenCashRegister(null);
            setReport(null);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        makeQuery();
    }, []);

    const formatCurrency = (value) => (value ?? 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const formatDateTime = (value) => new Date(value).toLocaleString('pt-BR');

    const onOpen = async () => {
        const parsedValue = Number.parseFloat(openingValue);
        if (Number.isNaN(parsedValue) || parsedValue < 0) {
            alert('Informe um valor de abertura válido.');
            return;
        }

        try {
            setLoading(true);
            const url = apiUrl + '/api/cash-registers';
            await makeRequest(url, 'POST', {
                'Content-Type': 'application/json',
                'Useruuid': Cookies.get('userUUID'),
            }, JSON.stringify({openingValue: parsedValue}));
            setOpeningValue('');
            await makeQuery();
        } catch (error) {
            console.error('Error opening cash register:', error);
            alert('Não foi possível abrir o caixa.');
        } finally {
            setLoading(false);
        }
    };

    const onClose = async () => {
        // eslint-disable-next-line no-restricted-globals
        if (!confirm('Deseja realmente fechar o caixa?')) {
            return;
        }
        try {
            setLoading(true);
            const url = apiUrl + '/api/cash-registers/' + openCashRegister.id + '/close';
            await makeRequest(url, 'PUT', {'Useruuid': Cookies.get('userUUID')});
            await makeQuery();
        } catch (error) {
            console.error('Error closing cash register:', error);
            alert('Não foi possível fechar o caixa.');
        } finally {
            setLoading(false);
        }
    };

    if (openCashRegister === undefined) {
        return null;
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflowY: 'auto'}}>
            <div className="header-label">Caixa</div>

            {openCashRegister ? (
                <>
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        <div style={{width: '180px'}}>Status:</div>
                        <div>Aberto</div>
                    </div>
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        <div style={{width: '180px'}}>Aberto em:</div>
                        <div>{new Date(openCashRegister.openedAt).toLocaleString('pt-BR')}</div>
                    </div>
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        <div style={{width: '180px'}}>Aberto por:</div>
                        <div>{openCashRegister.openedByUser?.name}</div>
                    </div>
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        <div style={{width: '180px'}}>Valor de abertura:</div>
                        <div>R$ {openCashRegister.openingValue.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}</div>
                    </div>

                    <div style={{marginTop: '20px', display: 'flex', gap: '10px'}}>
                        <button onClick={() => navigate('/cashregister/movement?type=entrada')}>Suprimento (Entrada)</button>
                        <button onClick={() => navigate('/cashregister/movement?type=saida')}>Sangria (Saída)</button>
                    </div>

                    {report &&
                        <>
                            <div className="header-label" style={{marginTop: '20px', fontSize: '18px'}}>Totais por Forma de Pagamento</div>

                            <table style={{width: '400px'}}>
                                <thead>
                                <tr>
                                    <th>Forma de Pagamento</th>
                                    <th>Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                {report.paymentMethodTotals.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.paymentMethodName}</td>
                                        <td>
                                            <div style={{textAlign: 'right'}}>R$ {formatCurrency(item.total)}</div>
                                        </td>
                                    </tr>
                                ))}
                                {report.paymentMethodTotals.length === 0 && (
                                    <tfoot>
                                    <tr>
                                        <td colSpan={2}>Nenhum pagamento registrado neste caixa.</td>
                                    </tr>
                                    </tfoot>
                                )}
                                </tbody>
                            </table>

                            {report.movements && report.movements.length > 0 &&
                                <>
                                    <div className="header-label" style={{marginTop: '20px', fontSize: '18px'}}>Sangrias / Suprimentos</div>
                                    <table style={{width: '100%'}}>
                                        <thead>
                                        <tr>
                                            <th>Data/Hora</th>
                                            <th>Tipo</th>
                                            <th>Forma de Pagamento</th>
                                            <th>Descrição</th>
                                            <th>Valor</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {report.movements.map((movement, index) => (
                                            <tr key={index}>
                                                <td>{formatDateTime(movement.createdAt)}</td>
                                                <td>{movement.type === MOVEMENT_TYPE_SANGRIA ? 'Sangria' : 'Suprimento'}</td>
                                                <td>{movement.paymentMethod?.name}</td>
                                                <td>{movement.description}</td>
                                                <td>
                                                    <div style={{textAlign: 'right'}}>R$ {formatCurrency(movement.value)}</div>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </>
                            }

                            <div style={{marginTop: '10px', alignItems: 'center'}}>
                                <div style={{width: '220px'}}>Total de Entradas (Suprimento):</div>
                                <div>R$ {formatCurrency(report.totalEntradas)}</div>
                            </div>
                            <div style={{marginTop: '5px', alignItems: 'center'}}>
                                <div style={{width: '220px'}}>Total de Saídas (Sangria):</div>
                                <div>R$ {formatCurrency(report.totalSaidas)}</div>
                            </div>

                            <div style={{marginTop: '5px', alignItems: 'center'}}>
                                <div className="total-label" style={{textAlign: 'right', fontSize: '30px', color: '#cc5545'}}>
                                    Saldo do Caixa: R$ {formatCurrency(report.grandTotal)}
                                </div>
                            </div>
                        </>
                    }

                    <ActionButtonsManagerView>
                        <button className="remove-button" onClick={onClose}>Fechar Caixa</button>
                    </ActionButtonsManagerView>
                </>
            ) : (
                <>
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        <div style={{width: '180px'}}>Status:</div>
                        <div>Fechado</div>
                    </div>
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        <div style={{width: '180px'}}>Valor de abertura:</div>
                        <input type="number" step="0.01" placeholder="0.00" style={{width: '150px'}}
                               value={openingValue}
                               onChange={(e) => setOpeningValue(e.target.value)}/>
                    </div>

                    <ActionButtonsManagerView>
                        <button onClick={onOpen}>Abrir Caixa</button>
                    </ActionButtonsManagerView>
                </>
            )}
        </div>
    );
};

export default CashRegister;
